import { AcademicLevel, Campus, Consentement, Email, FirstName, LastName, MobilePhoneRequired, Salutation, Section, Specialites } from "services/validation"
import * as Yup from "yup"

const schema = Yup.object().shape({
  ...Consentement,
  formations: Yup.array().min(1, 'Vous devez choisir au minimum une formation'),
  lead: Yup.object().shape({
    ...AcademicLevel,
    ...Campus,
    ...Email,
    ...FirstName,
    ...LastName,
    ...MobilePhoneRequired,
    ...Salutation,
    ...Section
  }),
  ...Specialites
})

export default schema
